import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Button, Card, Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

export type SelectTranscriptionDialogProps = {
  onSelect?: (sentence: string) => void
  sentences: string[]
}

export function SelectTranscriptionDialog(props: SelectTranscriptionDialogProps) {
  const { onSelect, sentences } = props
  const { t } = useTranslation()

  const [open, setOpen] = useState(false)

  return (
    <>
      <Button onClick={() => setOpen(true)} variant="contained">
        {t('page.expertise.dialogs.selectTranscription.openButton.label')}
      </Button>
      <Dialog onClose={() => setOpen(false)} open={open} fullWidth maxWidth="md" PaperProps={{ sx: { minHeight: '70%', pt: 5, px: 5 } }} scroll="paper">
        <DialogTitle>
          <Typography variant="h2">{t('page.expertise.dialogs.selectTranscription.title')}</Typography>
          <IconButton
            onClick={() => setOpen(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Stack direction="column" sx={{ mt: '20px' }} spacing="20px">
            {sentences.map((sentence: string) => (
              <Card
                sx={{ ':hover': { boxShadow: 2 }, p: 2, cursor: 'pointer' }}
                onClick={() => {
                  onSelect?.(sentence)
                  setOpen(false)
                }}
              >
                <Typography>{sentence}</Typography>
              </Card>
            ))}
          </Stack>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default SelectTranscriptionDialog
